import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../../../theme";

import { getTopPublishers } from "../../../redux/slices/dashboardSlice";
const AllPublishers = () => {
  const dispatch = useDispatch();
  const { topPublishers } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getTopPublishers());
  }, [dispatch]);

  return (
    <AdvertiserList>
      {topPublishers?.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          No publisher available.
        </div>
      ) : (
        topPublishers?.slice(0, 3).map((publisher) => (
          <AdvertiserCard>
            <AdvertiserHeader>
              {/* <img src={publisher?.imageUrl} alt={publisher?.name} /> */}
              <h4>{publisher?.publishername}</h4>
            </AdvertiserHeader>
            <Stats>
              <Stat>
                <Label>Campaigns</Label>
                <Value>{publisher?.totalcampaigns}</Value>
              </Stat>
              <Stat>
                <Label>Clicks</Label>
                <Value>{publisher?.totalreach}</Value>
              </Stat>
              <Stat>
                <Label>Conversions</Label>
                <Value>{publisher?.totalacquistion}</Value>
              </Stat>
            </Stats>
          </AdvertiserCard>
        ))
      )}
    </AdvertiserList>
  );
};

export default AllPublishers;

const AdvertiserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdvertiserCard = styled.div`
  padding: 16px;
  background: ${theme.color.surfaceAlt};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.md};
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${theme.color.brand};
    background: ${theme.color.surface};
  }
`;
const AdvertiserHeader = styled.div`
  display: flex;
  gap: 20px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  h4 {
    font-size: ${theme.font.body};
    font-weight: 600;
    color: ${theme.color.text};
    text-transform: capitalize;
  }
`;
const Stats = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 12px;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  text-align: left;
`;

const Label = styled.span`
  font-size: ${theme.font.tiny};
  color: ${theme.color.textMuted};
`;

const Value = styled.span`
  font-size: ${theme.font.body};
  font-weight: 600;
  color: ${theme.color.text};
`;
